import React from 'react';

const AverageStats = () => (
  <div className="md:mt-8 grid overflow-hidden md:grid-cols-3">
    <div className="px-4 py-5 md:p-6">
      <dl className="container mx-auto">
        <dt className="text-base leading-10 font-normal text-gray-900">Impressions served</dt>
        <dd className="mt-1 text-center pr-4">
          <div className="text-3xl leading-8 font-semibold text-indigo-600">~59,000,000</div>
        </dd>
      </dl>
    </div>

    <div className="border-t border-gray-200 md:border-0 md:border-l">
      <div className="px-4 py-5 md:p-6">
        <dl className="container mx-auto">
          <dt className="text-base leading-10 font-normal text-gray-900">Ad Clicks</dt>
          <dd className="mt-1 text-center pr-4">
            <div className="text-3xl leading-8 font-semibold text-indigo-600">~120,000</div>
          </dd>
        </dl>
      </div>
    </div>

    <div className="border-t border-gray-200 md:border-0 md:border-l">
      <div className="px-4 py-5 md:p-6">
        <dl>
          <dt className="text-base leading-10 font-normal text-gray-900">Conversions</dt>
          <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
            <div className="mx-auto lg:ml-10 flex items-baseline text-3xl leading-8 font-semibold text-indigo-600">
              ~5,000
              <span className="ml-2 text-sm leading-5 font-medium text-gray-500">hard leads</span>
            </div>
          </dd>
        </dl>
      </div>
    </div>

    <div className="border-t border-gray-200 lg:border-0 lg:mt-12 px-4 py-5 md:p-6">
      <dl>
        <dt className="text-base leading-10 font-normal text-gray-900">Pageviews</dt>
        <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div className="mx-auto lg:mr-6 flex items-baseline text-3xl leading-8 font-semibold text-indigo-600">
            ~129,400
            <span className="ml-2 text-sm leading-5 font-medium text-gray-500">
              website pageviews
            </span>
          </div>
        </dd>
      </dl>
    </div>
    <div className="lg:mt-12 border-t border-gray-200 md:border-0 md:border-l">
      <div className="px-4 py-5 md:p-6">
        <dl>
          <dt className="text-base leading-10 font-normal text-gray-900">
            Click-through Rate (CTR)
          </dt>
          <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
            <div className="mx-auto lg:ml-6 flex items-baseline text-3xl leading-8 font-semibold text-indigo-600">
              ~173.8%
              <span className="ml-2 text-sm leading-5 font-medium text-gray-500">
                avg. increase
              </span>
            </div>
          </dd>
        </dl>
      </div>
    </div>
    <div className="lg:mt-12 border-t border-gray-200 md:border-0 md:border-l">
      <div className="px-4 py-5 md:p-6">
        <dl>
          <dt className="text-base leading-10 font-normal text-gray-900">Cost/Conversion</dt>
          <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
            <div className="mx-auto flex items-baseline text-3xl leading-8 font-semibold text-indigo-600">
              ~$23.88
              <span className="ml-2 text-sm leading-5 font-medium text-gray-500">
                avg. cost per conversion
              </span>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </div>
);

export default AverageStats;

/*<div className="border-t border-gray-200 md:border-0 md:border-l">
<div className="px-4 py-5 md:p-6">
  <dl>
    <dt className="text-base leading-10 font-normal text-gray-900">Total Subscribers</dt>
    <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
      <div className="flex items-baseline text-3xl leading-8 font-semibold text-indigo-600">
        71,897
        <span className="ml-2 text-sm leading-5 font-medium text-gray-500">from 70,946</span>
      </div>
      <div className="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 bg-green-100 text-green-800 md:mt-2 lg:mt-0">
        <svg
          className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
        <span className="sr-only">Increased by</span>
        12%
      </div>
    </dd>
  </dl>
</div>
</div>*/
